import React from "react";
import { Link } from "react-router-dom";
import FadeInSection from "../FadeInSection";
import "./Mythology.css";

export default function MythologyConclusions() {
  return (
    <FadeInSection>
      <div className="myth-myths-page">
        <section className="hero-section" id="myth-conclusions-header">
          <div className="container">
            <Link to="/mythology" className="back-link">← mythology respawned</Link>
            <h1 className="hero-name myth-page-title">conclusions</h1>
            <p className="hero-role">what the ancient evidence shows</p>
          </div>
        </section>

        <section className="myth-myths-section">
          <div className="container">
            <div className="myth-entry">
              <p className="myth-analysis">
                Across these texts and artifacts, divine punishment in Greco-Roman
                mythology follows a consistent logic: the gods reduce their victims. A
                person's identity is stripped until only a single trait remains, and that
                trait becomes their entire function. Ovid's Arachne loses her body but keeps
                her craft: "she still spins a thread, and, as a spider, weaves her ancient
                web" (Metamorphoses 6.144–145). Echo keeps only repetition; after Hera's
                curse "she can repeat the last words out of many" (Metamorphoses 3.359–361).
              </p>
              <p className="myth-analysis" style={{ marginTop: "1rem" }}>
                The material evidence shows this idea reached beyond poetry. The Narcissus
                and Echo fresco from Pompeii put the myth on the wall of a private house,
                with Echo watching from the margin. The Tarentine gorgoneion antefix goes
                further: Medusa's punished face was mounted on temple roofs as a protective
                ward, which turned her reduction into architecture. The pattern was useful,
                so it was reproduced everywhere.
              </p>
              <p className="myth-analysis" style={{ marginTop: "1rem" }}>
                That usefulness is why the pattern survives. Overwatch's Widowmaker and Echo
                are built on this ancient template: a woman remade into a weapon, and an
                intelligence that can only mirror. Classical mythology persists in modern
                media because punishment through reduction remains one of the clearest ways
                to build a character.
              </p>
            </div>
          </div>
        </section>
      </div>
    </FadeInSection>
  );
}
